import type { ButtonHTMLAttributes } from 'react';
import { clsx } from 'clsx';

type ButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  variant?: 'primary' | 'secondary' | 'danger';
};

export const Button = ({ className, variant = 'primary', ...props }: ButtonProps) => (
  <button
    className={clsx(
      'inline-flex h-10 items-center justify-center gap-2 rounded-md px-4 text-sm font-semibold transition disabled:cursor-not-allowed disabled:opacity-50',
      variant === 'primary' && 'bg-brand-600 text-white hover:bg-brand-700',
      variant === 'secondary' && 'border border-line bg-white text-ink hover:bg-slate-50',
      variant === 'danger' && 'bg-signal-danger text-white hover:bg-red-700',
      className
    )}
    {...props}
  />
);
